const data = [
  {
    title: "Load More Data",
    shortDescription:
      "Don't crash your browser! Learn how to fetch data in small 'chunks' instead of loading 1000 items at once.",
    description:
      "Imagine if Instagram tried to load every photo ever posted the moment you opened the app—your phone would crash. This component solves that problem. We ask the API for just 20 items (a 'batch'). When you reach the bottom and click 'Load More', we ask for the *next* 20. In code, this introduces you to the concept of a 'Counter' or 'Skip' variable that keeps track of how many items you've already seen.",
  },
];

export default data;